const whatIDo = [
  "I build things for the web.",
  "I design user interfaces.",
  "I engineer back-ends.",
  "I assemble databases.",
  "I develop mobile apps.",
  "I maintain cloud solutions.",
  "I automate business processes.",
  "I train machine learning models.",
  "I build CI/CD pipelines.",
  "I create data visualizations.",
  "I write technical documentation.",
  "I lead software projects.",
]

export default whatIDo;